import * as z from "zod";

export const getOrderEditingOnboardingContext = {
  name: "getOrderEditingOnboardingContext" as const,
  input: z.object({}),
  output: z.object({
    appEmbedEnabled: z.boolean(),
    shopifyAppEmbedEditorUrl: z.string().nullish(),
    shopifyCheckoutEditorUrl: z.string().nullish(),
  }),
};
